<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h4 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">尊敬的，尊敬的各位来宾、各位朋友：</h4>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       今天，在这里，各位同仁齐聚蓉城，共商发展大计。在此，我谨代表，向莅临本次会议的各位来宾、各位朋友们表示诚挚的欢迎，向各位长期以来对建设和发展予以热情关心和大力支持的兄弟单位的全体同仁致以衷心的感谢。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       是共同创办的一个以提供优质机务保障、降低维修成本、协同机务维修发展规划为目标的极具战略发展意义的平台。在平台初创这一年多以来，始终保持着严谨、和谐、共进、发展的工作作风和良好的协同意识。工作卓有成效，获得了各单位及集团领导的高度认同和称赞。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       过往的一年，内各项工作得到了顺利的推进。特别是在前两次平台会议之后，各单位的落实平台各项主要业务指标上充分发挥了团结高效的工作作风，超额完成了20xx年度成本联动效应管理点。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       20xx年将是一个让平台工作再上台阶的具有里程碑意义的开端，也是实现发展和进步的重要一年。为此，我们将在新的一年里为打造一流XX企业，按照“”的指导思想，结合各发展战略，用平台办各项行动计划来对接落实协同战略，夯实协同基础、提升质量，实现长期可持续发展。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       时至隆冬，窗外风寒料峭，但我们的会场内，气氛是热烈的，感情是真挚的，成都这所美丽城市的热情感染了我们，我们认真、求实的工作与讨论同样给这所城市带来了XX人特有的激情。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       最后预祝此次国指导委员会第三次会议圆满成功，祝各位朋友在会议期间身体健康，工作顺利!愿各位的大力支持和协作中不断前进、再创辉煌!

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       谢谢大家!

      </p>
    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/yanjiang/2.vue